export enum EmailType {
  ConfirmEmail,
  ResetPassword,
}
